export class Aggregator {
  static sum(list: number[]): number {
    let result: number = 0;
    for (const i of list) {
      result += i;
    }
    return result;
  }

  static avg(list: number[]): number {
    return Aggregator.sum(list) / list.length;
  }

  static minSlice(toSlice: object, min: number): object {
    const result: object = {};
    for (const key in toSlice) {
      if (toSlice[key] >= min) {
        result[key] = toSlice[key];
      }
    }
    return result;
  }

  static maxSlice(toSlice: object | number[], max: number): number[] | object {
    const result: object = {};
    for (const key in toSlice) {
      if (toSlice[key] <= max) {
        result[key] = toSlice[key];
      }
    }
    return result;
  }
}
